var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.areaData.length > 0)?_c('Map',{attrs:{"config":_vm.config,"areaData":_vm.areaData,"renderAreaData":_vm.renderAreaData,"mapType":"养老机构","className":"org-baidu-map"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }